import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Pipes
import { SecondToYearMonthDaysPipe } from './pipes/month-year';
import { BudgetSummaryComponent } from './components/shared/budget-summary/budget-summary.component';


@NgModule({
  declarations: [
    SecondToYearMonthDaysPipe,
    BudgetSummaryComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SecondToYearMonthDaysPipe,
    BudgetSummaryComponent
  ]
})
export class ComunModule { }
